module.exports = __webpack_public_path__ + "media/Loops 110 Perc.fe7a6007.wav";